import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import PdfIcon from 'assets/images/PdfIcon.svg';
import { type ChatMessagesAttributesType } from 'types/services';
import { getResource } from 'service/UserService';

interface Props {
  message: ChatMessagesAttributesType;
  index: number;
  profileImage: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  colors: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customStyles: any;
  showAdditionalFields: boolean[];
  setShowAdditionalFields: React.Dispatch<React.SetStateAction<boolean[]>>;
  setOpenImageDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setViewImage: React.Dispatch<React.SetStateAction<string | null>>;
  setOpenComplaintDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setChatDescription: React.Dispatch<React.SetStateAction<string>>;
  setChatDetails: React.Dispatch<
    React.SetStateAction<ChatMessagesAttributesType>
  >;
}

const ComplaintChatMessageItem = ({
  message,
  customStyles,
  setOpenImageDialog,
  setViewImage,
}: Props): JSX.Element => {
  const [url, setUrl] = useState(null);

  const getUrl = async (key: string): void => {
    const data = await getResource(key);
    if (data.url) {
      setUrl(data.url);
    }
  };

  useEffect(() => {
    if (!message.imageUri || message?.fileType === 'application/pdf') return;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getUrl(message.imageUri);
  }, [message.imageUri]);

  return (
    <Box
      onClick={async () => {
        const res: { url: string } = await getResource(message.imageUri);
        if (!res?.url) return;
        if (message?.fileType === 'application/pdf') {
          const link = document.createElement('a');
          link.href = res.url;
          link.download = `download.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setOpenImageDialog(true);
          setViewImage(res.url);
        }
      }}
      sx={customStyles.cursorStyle}
    >
      {message.imageUri && (
        <>
          {message?.fileType === 'application/pdf' ? (
            <img style={customStyles.pdfIconStyle} src={PdfIcon} />
          ) : (
            <img
              src={url}
              style={customStyles.maxWidthStyle}
              alt="chat_image"
            />
          )}
        </>
      )}
    </Box>
  );
};

export default ComplaintChatMessageItem;
